import React, {ReactElement} from "react";

const PoweredBy: React.FC = (): ReactElement => {
    const version = process.env.REACT_APP_VERSION || 'dev';
    
    return (
        <div className="footer-right">
            Powered by{' '}
            <a href="https://www.cx.studio" target="_blank" rel="noopener noreferrer"
               style={{textDecoration: 'underline', color: 'inherit'}}>
                <b>CX Studio</b>
            </a>
            {' '}
            <span style={{opacity: 0.6, fontSize: '0.85em'}}>
                [{version}]
            </span>
        </div>
    );
};

export default PoweredBy;
